import { useAppSelector } from 'flow/hooks/useRedux';

import { TypedMap } from 'flow/types/TypedMap';
import { VoicemailSettings } from 'flow/types/VoicemailSettings';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';

interface VoicemailHook {
    voicemailSettings: TypedMap<VoicemailSettings>;
}

const useVoicemail = (extensionKey: string = null): VoicemailHook => {
    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);

    if (!extensionKey) {
        extensionKey = ownExtensionKey;
    }

    const voicemailSettings = useAppSelector((state) =>
        state.voicemail.get(extensionKey),
    );

    return { voicemailSettings };
};

export default useVoicemail;
